import { tv } from "@fanka/tailwind-variants";
import { clsx } from "clsx";

export const INPUT_CONTAINER_CLASS_NAME = tv({
  base: clsx(
    "w-full flex items-center max-w-[800px] outline-none border bg-ui-0 border-grayScale-200 rounded-[6px] pr-4 group",
  ),
  variants: {
    size: {
      md: "h-[40px]",
      lg: "h-[50px]",
    },
    error: {
      true: "border-functional-danger hover:bg-functional-danger-light focus-within:border focus-within:bg-functional-danger-light",
      false: "focus-within:border-2 focus-within:border-grayScale-400 hover:border-grayScale-400",
    },
    isDisabled: {
      true: "cursor-not-allowed border-grayScale-300 bg-grayScale-100 text-base-disabled hover:border-grayScale-300",
      false: "",
    },
  },
  defaultVariants: {
    size: "md",
    error: false,
  },
});

export const INPUT_CLASS_NAME = tv({
  base: "w-full h-full outline-none rounded-md pl-4 bg-[transparent]",
  variants: {
    isDisabled: {
      true: "cursor-not-allowed",
      false: "",
    },
  },
});
